module.exports = __webpack_public_path__ + "img/flag-UK.aac0dfef.png";